import { ApiConfig } from "../../Config/ApiConfig";
import { createFormDataAction, createGetDataAction, createPostDataAction } from "./CommonAction";
import { SERVICELIST  , SERVICEADD , SERVICECATEGORYLIST , SERVICEDETAILS ,SERVICESTATUS } from "../../Constants/ServiceConstants";



export const ServiceGetAction = (payload:any) => createPostDataAction(SERVICELIST, ApiConfig?.ServiceGetList,payload,false );
export const ServiceAddAction = (payload:any) => createPostDataAction(SERVICEADD, ApiConfig?.ServiceAdd,payload,false );
export const ServiceCategoryAddAction = (payload:any) => createPostDataAction(SERVICECATEGORYLIST, ApiConfig?.ServiceCategoryList,payload,false );
export const ServiceDtailsAction = (payload:any) => createPostDataAction(SERVICEDETAILS, ApiConfig?.ServiceDetails,payload,false );
export const ServiceStatusAction = (payload:any) => createPostDataAction(SERVICESTATUS, ApiConfig?.ServiceStatus,payload,true );
